import React, { useRef, useEffect } from "react";
import { Typography, Button, Modal } from "@mui/material";
import { useProfile } from "../../../context/ProfileContext";
import TimerComponent from "../../../components/TimerComponent";
import { useQuestionNavigator } from "../../../hooks/default/useQuestionNavigator";
import useExamProfileSectionStyle from "../testStyle/defaultStyle/examprofilesectionStyle";
import { decryptData } from "../../../crypto";
import { useQuestionSection } from "../../../hooks/default/useQuestionSection";
import { useLanguages } from "../../../context/LanguagesContext";
import userAvatar from '../../../images/userAvatar.png'

function QuestionNavigator({
  questionData,
  setCurrentQuestion,
  currentQuestion,
  handleDrawerToggle,
  handleToggleInstructionModal,
  openInstructionsModal,
  subjectId,
}) {
  const classes = useExamProfileSectionStyle();
  const boxRef = useRef(null);
  const questionRefs = useRef([]);

  const { profile } = useProfile();
  const { selectedLanguage } = useLanguages();
  const { questions } = useQuestionNavigator({ questionData, currentQuestion });
  const {
    setIsTimeUp,
    showSubmitModal,
    handleCloseSubmitModal,
    handleFinalSubmit,
    isTimeUp,
    stats,
    submitError,
    countdownTime,
    finalSubmitChecked,
    handleFinalSubmitCheck,
  } = useQuestionSection({
    questionData,
    currentQuestion,
    setCurrentQuestion,
    subjectId,
  });

  // Scroll to current question when it changes
  useEffect(() => {
    if (
      currentQuestion >= 0 &&
      questionRefs.current[currentQuestion] &&
      boxRef.current
    ) {
      const questionElement = questionRefs.current[currentQuestion];
      const boxElement = boxRef.current;

      // Calculate positions
      const boxRect = boxElement.getBoundingClientRect();
      const questionRect = questionElement.getBoundingClientRect();

      // Calculate scroll position
      const scrollPosition =
        questionRect.top -
        boxRect.top +
        boxElement.scrollTop -
        boxRect.height / 2 +
        questionRect.height / 2;

      // Smooth scroll
      boxElement.scrollTo({
        top: scrollPosition,
        behavior: "smooth",
      });
    }
  }, [currentQuestion]);

  return (
    <div className={classes.profileSection}>
      <div className={classes.profilesectioninner}>
        <div className={classes.imagecontainer}>
          <img
            className={classes.profilephoto}
            src={profile?.image_url || userAvatar}
            alt="Profile"
            width="100%"
            // onError={({ currentTarget }) => {
            //   currentTarget.onerror = null; // prevents looping
            //   currentTarget.src = "userAvatar.png";
            // }}
          />
        </div>
        <div className={classes.learnerinfo}>
          <Typography variant="body1">{profile?.full_name}</Typography>
          <Typography variant="body1">{profile?.phone}</Typography>
        </div>
      </div>

      <div className={classes.questionpallatemain}>
        <div className={classes.timer}>
          <Typography variant="h4" color="primary">
            Time Left:{" "}
            <TimerComponent
              setIsTimeUp={setIsTimeUp}
              showSubmitModal={showSubmitModal}
              handleCloseSubmitModal={handleCloseSubmitModal}
              handleFinalSubmit={handleFinalSubmit}
              isTimeUp={isTimeUp}
              stats={stats}
              submitError={submitError}
              countdownTime={countdownTime}
              finalSubmitChecked={finalSubmitChecked}
              onFinalSubmitCheck={handleFinalSubmitCheck}
            />
          </Typography>
        </div>
      </div>
      <div className={classes.numberbox}>
        <div className={classes.bgwhite}>
          <div className={classes.numberboxhead}>
            <Typography variant="h4" className={classes.questionLabel}>
              Questions
            </Typography>
          </div>

          <div className={classes.questionNumberBoxmain} ref={boxRef}>
            <div className={classes.questionNumberBoxmaininner}>
              {questions.map(({ status, number }, index) => {
                return (
                  <Button
                    ref={(el) => (questionRefs.current[index] = el)}
                    key={number}
                    id={`question-${number}`}
                    onClick={(event) => {
                      handleDrawerToggle();
                      setCurrentQuestion(index);
                    }}
                    className={`${classes.questionNumberBox} ${
                      currentQuestion === index ? "selected" : status || ""
                    }`}
                  >
                    {number}
                  </Button>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      <div className={classes.legend} 
      style={{flex:1}}
      >
        <div className={classes.legendinner2}>
          <span className={classes.current}></span>{" "}
          <Typography>Current Question</Typography>
        </div>
        <div className={classes.legendinner2}>
          <span className={classes.attempted}></span>{" "}
          <Typography>Answered</Typography>
        </div>
        {/* <div className={classes.legendinner2}>
          <span className={classes.notanswered}></span>{" "}
          <Typography>Not Answered</Typography>
        </div> */}
        {/* <div className={classes.legendinner2}>
          <span className={classes.markedanswer}></span>{" "}
          <Typography>Marked & Answered</Typography>
        </div>
        <div className={classes.legendinner2}>
          <span className={classes.markednotanswer}></span>{" "}
          <Typography>Marked & Not Answered</Typography>
        </div> */}
        <div className={classes.legendinner2}>
          <span className={classes.notviewed}></span>{" "}
          <Typography>Not viewed</Typography>
        </div>
      </div>
        <Button
          variant="contained"
          className={classes.transparentbtn}
          style={{position:'fixed',bottom:20}}
          onClick={handleToggleInstructionModal}
        >
          Instruction
        </Button>
      <div>

        {/* <Button
          variant="contained"
          className={classes.transparentbtn}
          onClick={handleToggleInstructionModal}
        >
          Instruction
        </Button> */}
        {/* Modal */}
        <Modal
          open={openInstructionsModal}
          onClose={handleToggleInstructionModal}
          className={classes.modal}
        >
          <div className={classes.modalContainer}>
            <div className={classes.modalHeader}>
              <Typography className={classes.modalTitle} variant="h4">
                Instructions
              </Typography>
              <Button
                className={classes.modalButton}
                onClick={handleToggleInstructionModal}
              >
                X
              </Button>
            </div>
            <div className={classes.modalContent}>
              <div
                dangerouslySetInnerHTML={{
                  __html:
                    selectedLanguage === "english"
                      ? decryptData(sessionStorage.getItem("examInstructions"))
                      : decryptData(
                          sessionStorage.getItem("instructionsHindi")
                        ),
                }}
              />
            </div>
          </div>
        </Modal>
      </div>
      
    </div>
  );
}

export default QuestionNavigator;
